import * as Yup from 'yup'
import { CONDITION_TYPE_OTHER } from './condition.values'
import ValidationShema from 'constants/ValidationShema';
import Tr from 'translations/Translations';
import ImputLimits from 'constants/InputLimits';

const limits = ImputLimits.procedure.condition;

export default (selectedItems) => Yup.lazy(values => {
	if (values.type !== CONDITION_TYPE_OTHER) {
		return Yup.object()
	}
	const reg = '^(?!(' + selectedItems.map(x => x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')+ ')$).*$';
	const otherNameRegExp = new RegExp(reg)
	return Yup.object().shape({
		otherName: ValidationShema.stringExactlyMax(
			otherNameRegExp,
			Tr('v_condition_exist'),
			limits.OTHER_NAME
		)
	})
})